import { defineStore } from 'pinia'
import { ListFrameThrottler } from '@/utils/ListFrameThrottler.ts'
import { ref } from 'vue'
import { formatDate } from '@/utils/timeUtils.ts'

interface PositionObj {
  id?: string
  account?: string
  typeCode?: string
  orderNo?: string
  direction?: string
  lots?: string
  takeProfit?: string
  stopLoss?: string
  entryPrice?: string
  currentPrice?: string
  floatingPL?: string
  margin?: string
  commission?: string
  overnightFee?: string
  timestamp?: string
  singleId?: string | number
  sort?: number
}

export const useOrderPositionStore = defineStore('orderPosition', () => {
  const positionOrderList = ref<PositionObj[]>([])

  const handleInfoListData = (list: PositionObj[]) => {
      list.forEach(item => {
          const idx = positionOrderList.value.findIndex(p => p.orderNo === item.orderNo)
          if (idx !== -1) {
              positionOrderList.value[idx] = item
              // console.log('update:', item);
          } else {
              positionOrderList.value.push(item)
              console.log('add:', item);
          }
      });

    positionOrderList.value.sort((a: PositionObj, b: PositionObj) => b.sort - a.sort)
  }

  const listFrameThrottler = new ListFrameThrottler(handleInfoListData)

  const updatePositionPricePL = async (itemStr:string) => {
      const fields = itemStr.split(':')
      const orderNo = fields[0]
      const currentPrice = fields[1]
      const floatingPL = fields[2]

      console.log('positionOrderList.value.findIndex(p => p.orderNo === orderNo):', positionOrderList.value.findIndex(p => p.orderNo === orderNo));
      if (positionOrderList.value.findIndex(p => p.orderNo === orderNo) === -1) return;

      // 构造仅用于更新的对象，只覆盖价格和盈亏字段
      const updateObj = {    
          id: orderNo, // 订单号
          orderNo,
          currentPrice,
          floatingPL: (Number(floatingPL) || 0).toFixed(2),
      }
      // 推入节流器，复用 ListFrameThrottler 的合并更新逻辑
      listFrameThrottler.push(updateObj)
  }
const clearPositionOrderList = () =>{
  positionOrderList.value = []
  listFrameThrottler.clear()
}
  const handlePositionOrderList = async (item:string) => {
    const fields = item.split(':')
    console.log(fields)
    const positionObj: PositionObj = {
      id: fields[2], // 订单号
      account: fields[0], // 账户id
      typeCode: fields[1], // 品种代码
      orderNo: fields[2], // 订单号
      direction: fields[3], // 1 做多 2 做空
      lots: fields[4], // 手数
      takeProfit: fields[5], // 止盈
      stopLoss: fields[6], // 止损
      entryPrice: fields[7], // 买入价格
      currentPrice: fields[8], // 当前价格
      floatingPL: (fields[9] * 1).toFixed(2), // 浮动盈亏
      margin: (fields[10] * 1).toFixed(2), // 保证金
      commission: (fields[11] * 1).toFixed(2), // 手续费
      overnightFee: (fields[12] * 1).toFixed(2), // 隔夜费
      timestamp:
        fields[13] === -1 || fields[13] === '' || fields[13] === '-1'
          ? ''
          : formatDate(fields[13] * 1000, 'YYYY-MM-DD HH:mm:ss'), // 时间戳
      singleId: fields[14] * 1 === 0 ? '--' : fields[14], // 带单人id
      sort: fields[13] * 1,
    }
    listFrameThrottler.push(positionObj)
  }

  return {
    clearPositionOrderList,
    positionOrderList,
    updatePositionPricePL,
    handlePositionOrderList,
  }
})
